/**
 * @generated SignedSource<<fa3ecc724c8165a8c16f67b69f379dbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_rankField$data = {
  readonly rankField?: {
    readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_rankField">;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_ListView_rankField";
};
export type main_issueNavigator_ListView_rankField$key = {
  readonly " $data"?: main_issueNavigator_ListView_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_rankField",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraJqlFieldWithAliases",
          "kind": "LinkedField",
          "name": "rankField",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ui_nativeIssueTable_NativeIssueTable_rankField"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "a97a4dfe64654347c948bfd1fa0c5092";

export default node;
